import script from "./AccountProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountProfile.vue?vue&type=script&setup=true&lang=js"

import "./AccountProfile.vue?vue&type=style&index=0&id=9198be7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9198be7a"]])

export default __exports__